import palette from './palette'

const { primary, secondary, border, white, rock, paper, scissors, lizard, spock, stop } = palette

const colors = {
  text: {
    primary,
    secondary,
    border
  },
  components: {
    button: {
      color: white,
      border: white,
      hover: {
        background: white,
        color: stop
      }
    },
    header: {
      border
    },
    thumb: {
      background: white,
      shadow: '#00000038',
      ROCK: rock[0],
      PAPER: paper[0],
      SCISSORS: scissors[0],
      LIZARD: lizard[0],
      SPOCK: spock[0]
    },
    modal: {
      title: primary
    }
  }
}

export default colors
